const Days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];
const DAYS_ABBRV = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
];
const Months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
const DAYS_OF_WEEK = [
    { abbriv: "sun", name: "Sunday" },
    { abbriv: "mon", name: "Monday" },
    { abbriv: "tue", name: "Tuesday" },
    { abbriv: "wed", name: "Wednesday" },
    { abbriv: "thu", name: "Thursday" },
    { abbriv: "fri", name: "Friday" },
    { abbriv: "sat", name: "Saterday" },
];
const WEEK = {
    DAYS: DAYS_OF_WEEK,
    FIRST_DAY: DAYS_OF_WEEK[0],
    LENGTH: DAYS_OF_WEEK.length,
};
const MONTHS = [
    { abbriv: "jan", name: "January" },
    { abbriv: "feb", name: "February" },
    { abbriv: "mar", name: "March" },
    { abbriv: "apr", name: "April" },
    { abbriv: "may", name: "May" },
    { abbriv: "jun", name: "June" },
    { abbriv: "jul", name: "July" },
    { abbriv: "aug", name: "August" },
    { abbriv: "sep", name: "September" },
    { abbriv: "oct", name: "October" },
    { abbriv: "nov", name: "November" },
    { abbriv: "dec", name: "December" },
];
const MS_IN_SEC = 1000;
const SEC_IN_MIN = 60;
const MIN_IN_HR = 60;
const HRS_IN_DAY = 24;
const DAYS_IN_WK = 7;
const MS_IN_MIN = MS_IN_SEC * SEC_IN_MIN; //      60,000
const MS_IN_HR = MS_IN_MIN * MIN_IN_HR; //   3,600,000
const MS_IN_DAY = MS_IN_HR * HRS_IN_DAY; //  86,400,000
const DAYLENGTH = MS_IN_DAY; //  86,400,000
const WEEKLENGTH = DAYLENGTH * DAYS_IN_WK; // 604,800,000
/* eslint-disable no-magic-numbers */
/* eslint-disable array-bracket-newline */
export const magicNumbers = {
    month: {
        in: {
            year: (1 / 12),
            day: (365 / 12),
        },
        to: {
            hours: (7 * 24),
            minutes: (7 * 24 * 60),
            seconds: (7 * 24 * 60 * 60), // 604800
        },
    },
    week: {
        in: {
            year: 52,
        },
        to: {
            hours: (7 * 24),
            minutes: (7 * 24 * 60),
            seconds: (7 * 24 * 60 * 60), // 604800
        },
    },
    day: {
        in: {
            year: 365,
            month: (365 / 12),
            week: 7, // 0.1428
        },
        to: {
            hours: (24),
            minutes: (24 * 60),
            seconds: (24 * 60 * 60),
            miliseconds: (24 * 60 * 60 * 1000),
        }
    },
    hour: {
        in: {
            year: (24 * 365),
            month: (24 * 365 / 12),
            week: (24 * 7),
            day: (24)
        }
    },
    minutes: {
        in: {
            halfHour: (30),
            hour: (60),
            day: (60 * 24),
            week: (60 * 24 * 7),
        }
    },
    seconds: {
        in: {
            minute: (60),
            halfHour: (60 * 30),
            hour: (60 * 60),
            day: (60 * 60 * 24),
            week: (60 * 60 * 24 * 7),
        }
    },
    ms: {
        in: {
            minute: (1000 * 60),
            halfHour: (1000 * 60 * 30),
            hour: (1000 * 60 * 60),
            day: (1000 * 60 * 60 * 24),
            week: (1000 * 60 * 60 * 24 * 7),
        }
    },
};
export const WK_LENGTH = {
    FUN: [3],
    BAS: [4, 6],
    ADV: [4, 6, 8],
    TST: [1, 2, 3, 4, 5, 6, 7, 8],
};
export const EVENT_LENGTH = {
    "test": [1, 2, 3, 4, 5, 6, 7, 8],
    "executive": [12],
    "advanced": [4, 6, 8],
    "fundamentals": [3],
};
export const commonStrings = {
    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
};
export const CONSTS = {
    commonStrings,
    DAYLENGTH,
    DAYS_ABBRV,
    DAYS_IN_WK,
    Days,
    EVENT_LENGTH,
    HRS_IN_DAY,
    MIN_IN_HR,
    MS_IN_DAY,
    MS_IN_HR,
    MS_IN_MIN,
    MS_IN_SEC,
    Months,
    SEC_IN_MIN,
    WEEKLENGTH,
    WK_LENGTH,
    magicNumbers,
};
export const constants = {
    commonStrings,
    WEEK,
    DAYS_OF_WEEK,
    MONTHS,
};
export default constants;
//# sourceMappingURL=constants.js.map